import * as React from 'react';
import { highlightMarker } from '@/utils/utils';
import { RiskFactor } from '@/common/js/constant';
import { setCommonAttrs, trackEvent } from '@/utils/omega';


type PageChooseProps = { 
  title: string;
  description: string;
  options: RiskVerifyOption[];
  onChoose: (value: RiskFactor) => void;
};

export default function PageChoose (props: PageChooseProps) {

  // 选择验证方式
  const handleChoose = (method: RiskFactor, rank: number) => {
    props.onChoose(method);
    // 上报埋点
    trackEvent('fin_verification_method_ck', {
      // option 点击的选项名称
      option: method,
      // rank 点击选项的位次（0开始）
      rank,
      // 核验方式
      // 0 单因子
      // 1 双因子
      result_status: String(method).indexOf('+') > 0 ? 1 : 0
    });
  }

  // 关闭核验列表
  const handleCancel = () => {
    props.onChoose(RiskFactor.NOTHING);
    // 上报埋点
    trackEvent('fin_verification_method_ck', {
      // option: 1
    });
  }

  // 
  React.useEffect(() => {
    // 设置pub page
    setCommonAttrs({ pub_page: 'verification_method'});
    // 上报埋点
    trackEvent('fin_verification_method_sw', {
      option: JSON.stringify(props.options)
    });
  }, [])


  return <div className='page-choose'>
    <div className='btn-page-choose-back' onClick={ handleCancel }></div>
    <h1>{ props.title }</h1>
    <p>{ props.description }</p>
    <ul className='list'>
        {
          props.options.map((item, index) => <li key={ index } className='item' onClick={ handleChoose.bind(null, item.name, index) } dangerouslySetInnerHTML={{__html: highlightMarker(item.title) }} />)
        }
    </ul>
  </div>
}

